import { useDidMount } from '@djs/react';
import { linkIosManifest, saveHash } from '@pwa';
import { L } from '@lang';
import { resolvePath } from '@djs';
import { getFilename } from '@djs/path';
import { getPageKey } from './getPageKey';
import { MyTrackerEvents, sendMtEvent, sendYaMetrikaEvent, YaMetrikaEvents } from '../../core/services/myTracker';
import { envs, useAppContext } from '../../core';
import { PwaPage } from './enums';
import { getManifestIcon } from '../../helpers/getManifestIcon';

const PAGE_MAP_TO_TRACKER_EVENTS: { [key in PwaPage]: { mt: MyTrackerEvents; ym: YaMetrikaEvents } } = {
  [PwaPage.DisabledIos]: {
    mt: MyTrackerEvents.PwaIosInstallDisabled,
    ym: YaMetrikaEvents.PwaIosInstallDisabled,
  },
  [PwaPage.DisabledAndroid]: {
    mt: MyTrackerEvents.PwaAndroidInstallDisabled,
    ym: YaMetrikaEvents.PwaAndroidInstallDisabled,
  },
  [PwaPage.InstallSafariIos26]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallSafariIos27]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallUnavailableOnOldIos]: {
    mt: MyTrackerEvents.PwaOldIosInstructionOpened,
    ym: YaMetrikaEvents.PwaOldIosInstructionOpened,
  },
  [PwaPage.InstallOldSafari]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallChrome]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallYandex]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallOther]: {
    mt: MyTrackerEvents.PwaCopyInstructionOpened,
    ym: YaMetrikaEvents.PwaCopyInstructionOpened,
  },
  [PwaPage.InstallDesktop]: {
    mt: MyTrackerEvents.PwaQrInstructionOpened,
    ym: YaMetrikaEvents.PwaQrInstructionOpened,
  },
};

export function usePwaInstallControllerState() {
  const { deviceInfo } = useAppContext();
  const pageKey = getPageKey(deviceInfo);

  useDidMount(() => {
    if (deviceInfo.mobileOS?.name === 'ios') {
      const appId = new URLSearchParams(window.location.search).get('appId') || undefined;
      const url = window.location.href;
      const host = window.location.host;

      const installUrl = resolvePath({ href: url, path: envs.LAUNCHER_PATH, skipHash: true });

      saveHash();
      linkIosManifest({
        appId,
        images: {
          '192': resolvePath({
            href: url,
            path: getManifestIcon('192.png', host),
            skipHash: true,
            skipQuery: true,
          }),
          '512': resolvePath({
            href: url,
            path: getManifestIcon('512.png', host),
            skipHash: true,
            skipQuery: true,
          }),
        },
        projectName: L.t('project_name'),
        pwaNamePrefix: envs.PWA_NAME_PREFIX,
        startUrl: resolvePath({ href: installUrl, path: getFilename(url) }),
      });
    }
  });

  useDidMount(() => {
    const event = PAGE_MAP_TO_TRACKER_EVENTS[pageKey];
    sendMtEvent(event.mt);
    sendYaMetrikaEvent(event.ym);
  });

  return pageKey;
}
